<table mat-table [dataSource]="dataSource">
	<caption></caption>
	<ng-container matColumnDef="select">
		<th mat-header-cell *matHeaderCellDef>
			<mat-checkbox
				(change)="$event ? toggleAllRows() : null"
				[checked]="selection.hasValue() && isAllSelected()"
				[indeterminate]="selection.hasValue() && !isAllSelected()"
				[aria-label]="checkboxLabel()"
			>
			</mat-checkbox>
		</th>
		<td mat-cell *matCellDef="let row">
			<mat-checkbox
				(click)="$event.stopPropagation()"
				(change)="$event ? toggleRow(row) : null"
				[checked]="selection.isSelected(row)"
				[aria-label]="checkboxLabel(row)"
			>
			</mat-checkbox>
		</td>
	</ng-container>

	<ng-content></ng-content>
	<ng-container matColumnDef="selectionFooter">
		<td mat-footer-cell *matFooterCellDef [attr.colspan]="columns.length">
			{{ selection.selected.length }}
			{{ selection.selected.length === 1 ? 'registro seleccionado' : 'registros seleccionados' }}
		</td>
	</ng-container>

	<tr mat-header-row *matHeaderRowDef="columns"></tr>
	<tr mat-row *matRowDef="let row; columns: columns"></tr>
	<tr mat-footer-row *matFooterRowDef="['selectionFooter']"></tr>
</table>

<mat-paginator
	*ngIf="showPaginator"
	[pageSizeOptions]="[5, 10, 25, 50]"
	[pageSize]="5"
	aria-label="Seleccionar página de la tabla"
></mat-paginator>
